import { render, staticRenderFns } from "./FabricsList.vue?vue&type=template&id=4f5eca1a&scoped=true"
import script from "./FabricsList.vue?vue&type=script&lang=js"
export * from "./FabricsList.vue?vue&type=script&lang=js"
import style0 from "./FabricsList.vue?vue&type=style&index=0&id=4f5eca1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5eca1a",
  null
  
)

export default component.exports